<template>
  <b-container v-if="this.getEstablecimiento">
    <div class="white">
      <h1 class="mb-4 display-title">Nómina de Personal</h1>
      <h6></h6>
      <hr />
      <b-row v-if="isInRoleAdmin">
        <b-col cols="12">
          <!-- <calendar-heatmap :locale="es_locale" :range-color="['ebedf0', 'dae2ef', '#c0ddf9', '#73b3f3', '#3886e1', '#17459e']" :max="1000" no-data-text="No hay datos para este día"  :values="[{ date: '2018-9-22', count: 6 }, { date: '2019-9-22', count: 1 }]" :end-date="2020-9-22" tooltip-unit="ausencias" /> -->
          <calendar-heatmap :locale="es_locale" :max="100" no-data-text="No hay datos para este día"  :values="heatmap" end-date="2021-07-17" tooltip-unit="solicitudes" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Apellido y Nombre ">
            <b-form-input
              v-model="search"
              @input="onSearchInput"
              placeholder="Buscar"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Por página: ">
            <b-form-select
              :options="pageOptions"
              v-model="perPage"
              @change="obtenerPersonal"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-row class="mt-4">
      <b-col lg="12">
        <b-alert show variant="warning" v-if="this.personal.length == 0"
          >No se encontraron resultados</b-alert
        >
        <ListaPersonal :lista="personal" />
        <p class="mt-4">
          Mostrando {{ currentPage }} a {{ perPage }} de {{ totalRows }} items
        </p>

        <b-pagination
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
          @input="obtenerPersonal"
          class="nav justify-content-center mt-4 mb-4"
        />
      </b-col>
      <b-col lg="6"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import { CalendarHeatmap } from 'vue-calendar-heatmap'
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import LicenciaCargoPersonalSvc from "@/services/licenciacargopersonal";
import PersonalSvc from "@/services/personal";
import CargoPersonalSVC from "@/services/cargopersonal";
import Solicitudsvc from "@/services/solicitudes";
import ListaPersonal from "../../common/ListaPersonal.vue";

export default {
  components: { ListaPersonal },
  computed: {
    ...mapGetters([
      "getEstablecimiento",
      "isInRoleAdmin",
      "isInRoleCoordinador",
      "isInRoleEstablecimiento",
      "isInRoleRecMedico"
    ]),
    DisplayPersonal: function() {
      return this.formulario.modalEnviar.personal.InformacionPersonal
        ? this.formulario.modalEnviar.personal.InformacionPersonal
            .DisplayDniNombre
        : "";
    },
    DisplayCargoPersonal: function() {
      var cargosSeleccionados = [];
      this.cargopersonal.forEach(cp => {
        if (this.checkedItems.indexOf(cp.Id) >= 0) {
          cargosSeleccionados.push(cp);
        }
      });
      return cargosSeleccionados;
    }
  },
  watch: {
    getEstablecimiento: function(newvalue, oldvalue) {
      this.currentPage = 1;
      this.obtenerPersonal();
    }
  },
  data() {
    return {
      heatmap: [{ date: '2018-9-22', count: 6 }, { date: '2019-9-22', count: 1 }],
      es_locale: {
        months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        on: 'en',
        less: 'Men',
        more: 'Mas'
      },
      titulo: "Nómina de Personal",
      personal: [],
      solicitudseleccionada: null,
      listacargosagregar: [],
      disabled: null,
      unidadId: "",
      nivelSolicitud: "",
      checked: true,
      totalRows: null,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 25],
      search: "",
      searchDebounceTimer: null,
      cancelBusquedaPersonal: null
    };
  },
  methods: {
    toggleSelected() {
      this.checkedItems = this.selectAll ? this.cargosSeleccionados : [];
    },
    modalAgregarCargo(item, index, button) {
      console.log("item ", item);
      console.log("index ", index);
      this.listacargosagregar = [];
      Solicitudsvc.get({ id: item.Id, incluyecargopersonal: true }).then(e => {
        console.log(e);
        this.solicitudseleccionada = e.data.objeto;
        this.solicitudseleccionada.ListaCargoPersonal.forEach(obj => {
          console.log("obj: ", obj);
          this.datosDocente.forEach(elem => {
            console.log(elem);
            var cargoagregar = elem;
            cargoagregar.activo = false;
            cargoagregar.antiguedad =
              moment().diff(elem.FechaDesde, "years", false) + " años";
            if (elem.Id === obj.Id) {
              cargoagregar.activo = true;
            }
            this.listacargosagregar.push(elem);
          });
        });
      });
      this.$root.$emit("bv::show::modal", "agregarCargoMOD", button);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    obtenerHeatmap: function() {
      Solicitudsvc.getHeatMap().then(r => {
        console.log('getheatmap',  r.data.rows);
        this.heatmap = r.data.rows.map(i =>  { return { date: i.Fecha, count: i.Cantidad } })
        console.log('getheatmap', this.heatmap);
      });
    },
    onSearchInput: function() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.currentPage = 1;
        this.obtenerPersonal();
      }, 350);
    },
    obtenerPersonal: function(ctx) {
      if (this.cancelBusquedaPersonal) {
        this.cancelBusquedaPersonal();
      }
      const source = axios.CancelToken.source();
      this.cancelBusquedaPersonal = source.cancel;
      let promise = PersonalSvc.getLista({
        incluyecargopersonal: true,
        search: this.search,
        unidadEducativa_Id: this.getEstablecimiento
          ? this.getEstablecimiento.UnidadEducativa_Id
          : 0,
        nivelEnseñanza_Id: this.getEstablecimiento
          ? this.getEstablecimiento.NivelEnseñanza_Id
          : 0,
        offset: (this.currentPage - 1) * this.perPage,
        limit: this.perPage
      }, { cancelToken: source.token });
      return promise
        .then(r => {
          this.personal = r.data.rows;
          this.totalRows = r.data.total;
          return this.personal;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            console.log("Error en obtenerPersonal()", error);
          }
        });
    }
  },
  created() {
    if (this.isInRoleAdmin) {
      this.obtenerHeatmap();
    }
    this.obtenerPersonal();
  }
};
</script>

<style>
.display-cuil {
  font-weight: 700;
  color: rgb(53, 53, 53);
}
.blue {
  color: #1771b4ff;
  font-weight: 500;
}
.italica {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/personal/Personal.vue